import cn from 'classnames'

import { Input } from '../index'
import { InputProps } from '../Input/Input'

interface Props extends InputProps {
  label?: string
  className?: string
}

export const FormInput = (props: Props) => {
  const { label, className, ...rest } = props

  const baseJsx = <Input {...rest} className="form-input" />

  return (
    <div className={cn('form-input-wrapper', className)}>
      {label ? (
        <label className="form-label">
          <span className="input-label">{label}</span>
          {baseJsx}
        </label>
      ) : (
        baseJsx
      )}
    </div>
  )
}
